import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="bg-[#0f0f0f] py-24" data-id="element-1">
      <div className="mx-auto max-w-6xl px-6" data-id="element-2">
        <div className="mb-16 text-center" data-id="element-3">
          <h2 className="text-3xl font-bold tracking-tight text-white md:text-4xl" data-id="element-4">
            Para quién es (y para quién no)
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-2" data-id="element-5">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl border border-green-900/30 bg-green-950/10 p-8" data-id="element-6">
            <h3 className="mb-6 flex items-center gap-3 text-xl font-bold text-white" data-id="element-7">
              <CheckCircle2 className="text-green-500" data-id="element-8" />
              Es para ti si:
            </h3>
            <ul className="space-y-4 text-gray-300" data-id="element-9">
              <li className="flex gap-3" data-id="element-10">
                <span className="text-green-500" data-id="element-11">•</span>
                Creas contenido en TikTok/Meta y algo cambió de golpe.
              </li>
              <li className="flex gap-3" data-id="element-12">
                <span className="text-green-500" data-id="element-13">•</span>
                Necesitas un plan corto, ejecutable y medible.
              </li>
              <li className="flex gap-3" data-id="element-14">
                <span className="text-green-500" data-id="element-15">•</span>
                Quieres calma operativa sin “motivación”.
              </li>
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl border border-red-900/30 bg-red-950/10 p-8" data-id="element-16">
            <h3 className="mb-6 flex items-center gap-3 text-xl font-bold text-white" data-id="element-17">
              <XCircle className="text-red-500" data-id="element-18" />
              No es para ti si:
            </h3>
            <ul className="space-y-4 text-gray-300" data-id="element-19">
              <li className="flex gap-3" data-id="element-20">
                <span className="text-red-500" data-id="element-21">•</span>
                Buscas evadir políticas o “hackear” la plataforma.
              </li>
              <li className="flex gap-3" data-id="element-22">
                <span className="text-red-500" data-id="element-23">•</span>
                Quieres garantías de views/monetización (nadie serio puede
                prometer eso).
              </li>
              <li className="flex gap-3" data-id="element-24">
                <span className="text-red-500" data-id="element-25">•</span>
                No vas a seguir pasos y quieres saltarte al “truco”.
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}